import React, { useState, useEffect } from 'react'
import { Provider } from 'react-redux'
import store from './store'
import DMSForm from './formSections';
import EUAcknowledgementPage from '../Acknowledgement/acknowledgement';
import EUHeader from '../../header'
import ShipmentInfoProvider from '../context/shipmentInfo.js';
import { getJobStates, getJobWheels, isShipmentDisabled } from '../../components/util'
import { SAVE_FORM_NL, DELETE_NL_ENTITY } from '../NL_App/api/apiEvents'
import DmsEuHeader from './dmsEuHeader';

const DMSApp = (props) => {
  const [shipmentId, updateShipmentId] = useState(props?.shipId)
  const [shipmentMode, updateShipmentMode] = useState('ES')

  useEffect(() => {
    updateShipmentId(props?.shipId)
    updateShipmentMode('ES')
  }, [props?.shipId])

  const jobWheels = getJobWheels(props?.currentJobData);
  const getJobWheel = getJobStates(jobWheels)

  const currentJobState = getJobWheel('ES_ENTRY_JOB_WHEEL')
  const customJobState = getJobWheel('NL_CUSTOM_JOB_WHEEL')
  const currentJobCircuitState = getJobWheel('CUSTOM_RELEASE_WHEEL')
  const brokerHouseState = jobWheels ? getJobWheel('SHIPMENT_BROKER_HOUSE_PROCESS') : ''
  const isFormDisabled = isShipmentDisabled(currentJobState, customJobState, currentJobCircuitState, brokerHouseState, (shipmentMode==='RFI-1'))
  const isRFIDisabled = ['STATE_ENTRY_RFI_FILED', 'STATE_ENTRY_RFI_ACCEPTED']?.includes(currentJobState)
  return (
    <Provider store={store}>
      <ShipmentInfoProvider
        shipmentId={shipmentId}
        updateShipmentId={updateShipmentId}
        updateShipmentMode={updateShipmentMode}
        countryCode={props?.shipmentCountry}
        version={props?.formType}
        deleteEvent={DELETE_NL_ENTITY}
        saveEvent={SAVE_FORM_NL}
        serviceType={props?.serviceType}
        isDisabled={isFormDisabled}
        currentJobData={props?.currentJobData}
        jobWheels={jobWheels}
        isRFI={(shipmentMode==='RFI-1')}
        isRFIDisabled={isRFIDisabled}
        currentJobState={currentJobState}
        customJobState={customJobState}
        kxEngineUserInfo={props?.kxEngineUserInfo}
      >
        <DmsEuHeader
          shipmentId={props?.shipId}
          renderEuHeader={(extraProps) => <EUHeader
            translate={props.translate}
            shipId={props.shipId}
            EUData={props.EUData}
            setEUData={props.setEUData}
            shipmentCountry={props.countryCode}
            kxUser={props.kxUser}
            {...props.headerProps}
            version={props.version}
            {...extraProps}
            kxEngineUserInfo={props?.kxEngineUserInfo}
          />}
        />
        {props.finalReview ?
          <EUAcknowledgementPage
            euPdf={props.euPdf}
            key='finalReview'
            handleLegalAcknowledgement={props.handleLegalAcknowledgement}
            loadShipment={props.loadShipment}
            translate={props.translate}
            countryCheck={props.currentJobData?.countryCode}
          />
          : <DMSForm
            shipmentMode={shipmentMode}
            updateShipmentMode={updateShipmentMode}
            updateShipmentId={updateShipmentId}
            {...props}
          />
        }
      </ShipmentInfoProvider>
    </Provider>
  )
}

export default React.memo(DMSApp);
